export default {
	upsertList(state, payload) {
		state.list = { ...state.list, ...payload }
	},

	addToList(state, payload) {
		state.list.products.unshift(payload)
	},

	addVersionToProduct(state, payload) {
		const product = state.list.products.find(
			product => product?.productId?.type === payload?.productId?.type && product?.productId?.plan === payload?.productId?.plan
		)

		if (!product?.versions) product.versions = []
		product.versions.unshift(payload)
	}
}
